import { isEmpty } from "lodash";
import zustandShallow from "zustand/shallow";

export const validateParams = (params: any) => {
    if (isEmpty(params)) {
        // Forcibly convert {} "" false etc. to null for react query
        return null;
    }

    if (params && ("enabled" in params || "staleTime" in params)) {
        console.error("You may be passing in react-query flags in your params instead of options (third argument)");
    }

    return params;
};

/*
  following is not working as expected due to zustand's shallow does not support arrays,
  it always flags the state as "changed" causing React to render the component everytime.

  const [itemA, itemB] = useStore((state) => [state.itemA, state.itemB], shallow);

  this function is a wrapper to zustand's shallow which prevents that.
*/
export const shallow = (itemA: any, itemB: any): boolean => {
    if (!Array.isArray(itemA) || itemA.length === 0 || !Array.isArray(itemB) || itemB.length === 0) {
        return zustandShallow(itemA, itemB);
    }

    if (itemA.length !== itemB.length) {
        return false;
    }

    for (const [index, value] of itemA.entries()) {
        if (!zustandShallow(value, itemB[index])) {
            return false;
        }
    }

    return true;
};
